// MINIMUM DE COMMANDE : LE BOUTON DE LA FICHE PRODUIT
// Sur la fiche d'un produit a minimum (inc/minimum-commande.php), le bouton d'ajout au panier est
// grise et inactif tant que la quantite choisie est sous le minimum. Le champ part du minimum :
// le bouton ne se grise que si la cliente tape moins. Ce n'est qu'un confort, le serveur refuse
// de toute facon un ajout sous le minimum.
//
// Le bouton est vise par son type, pas par sa classe : sur un produit simple, le gabarit
// d'Understrap ne lui donne pas `single_add_to_cart_button`, seulement `btn btn-outline-primary`.
// Le script des variations de WooCommerce ne joue que sur des classes : la propriete disabled
// posee ici n'entre pas en conflit avec lui.
jQuery(document).ready(function($) {

	var $mention = $('.js-minimum-commande').first();
	if ($mention.length === 0) return;

	var minimum = parseInt($mention.attr('data-minimum'), 10);
	if (!(minimum > 1)) return;

	var $form = $('form.cart').first();
	var $bouton = $form.find('button[type="submit"]');

	function actualiser() {
		var quantite = parseInt($form.find('input.qty[name="quantity"]').val(), 10);
		var sousMinimum = isNaN(quantite) || quantite < minimum;

		$bouton
			.prop('disabled', sousMinimum)
			.attr('aria-disabled', sousMinimum ? 'true' : 'false')
			.toggleClass('is-sous-minimum', sousMinimum);
	}

	$form.on('change input', 'input.qty[name="quantity"]', actualiser);
	actualiser();
});
